export const enum ArticleType {
  DISCOVER = "DISCOVER",
  BKK = "BKK",
  COMPANY = "COMPANY",
}
